import React from 'react';
import { string, node } from 'prop-types';
import classNames from 'classnames';

import './style.scss';

const Footer = ({ className, children }) => <div className={classNames('modal-actions', className)}>{children}</div>;

Footer.propTypes = {
    className: string,
    children: node,
};

export default Footer;
